// extracted by mini-css-extract-plugin
export default {"loader":"FHe0abRbyKE0Af9a9aWu","rotate":"wS0BQDB4eGpNdEgOWow3","loader__holder":"Lv4lcgKo713Kg2oMaP4p"};